import { render, staticRenderFns } from "./PointsManagement.vue?vue&type=template&id=8ade851c&scoped=true"
import script from "./PointsManagement.vue?vue&type=script&lang=js"
export * from "./PointsManagement.vue?vue&type=script&lang=js"
import style0 from "./PointsManagement.vue?vue&type=style&index=0&id=8ade851c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ade851c",
  null
  
)

export default component.exports